import { render, staticRenderFns } from "./MarksGroupRootView.vue?vue&type=template&id=5a5a229d"
import script from "./MarksGroupRootView.vue?vue&type=script&lang=js"
export * from "./MarksGroupRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports